<style type="text/css" lang="stylus">
@import '../config/var-css'
    body
        height auto !important
    .copyright
        left 0
        bottom rem(30)
        width 100%
        font-size $font-size-tip
        color $tip-color !important
        text-align center
        line-height $line-height-base
        position absolute
        z-index 10
</style>
<template>
<div class="copyright">
    <slot>
        <p v-if="!isMT">{{$dmt('title')}} | PINTEC旗下智能信贷技术服务提供商</p>
        <p v-if="isMT">小提示：请在&nbsp;<em>我-钱包-现金分期</em>&nbsp;操作借还款哦</p>
        <p v-if="isMT">PINTEC | 上海安趣盈科技有限公司技术服务提供商</p>
        <p>借款资金由合作金融机构提供  沪ICP备16021364号-1</p>
    </slot>
</div>
</template>
<script>
  import Vue from 'vue'
  
  export default {
    data () {
      return {
            isMT: false  //美图
      }
    },
    mounted () {
      if (Vue.cookie('partner') && Vue.cookie('partner') == 'idmiao635') {
        this.isMT = true;
      }
    }
  }
</script>
